import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramComparePostDetails.graphql';
import { Query, QueryinstagramComparePostDetailsArgs } from '../../__generated__/globalTypes';

export const useInstagramComparePostDetailsQuery = (
  options?: QueryHookOptions<Query, QueryinstagramComparePostDetailsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramComparePostDetailsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramComparePostDetailsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramComparePostDetailsArgs>
): QueryResult<Query, QueryinstagramComparePostDetailsArgs> & {
  getInstagramComparePostDetails: LazyQueryExecFunction<Query, QueryinstagramComparePostDetailsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramComparePostDetails, result] = useLazyQuery<Query, QueryinstagramComparePostDetailsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInstagramComparePostDetails, ...result };
};

export const useInstagramComparePostDetailsPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramComparePostDetails = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramComparePostDetailsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramComparePostDetailsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramComparePostDetails };
};
// Suspense Query Hooks
export const useInstagramComparePostDetailsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramComparePostDetailsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramComparePostDetailsArgs>(QUERY, {
    ...options
  });

  return result;
};
